import { Component, OnInit } from '@angular/core';
import { Quiniela } from 'src/app/models/quiniela';
import { QuinielasService } from 'src/app/services/quinielas.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-pago-page',
  templateUrl: './pago-page.component.html',
  styleUrls: ['./pago-page.component.css']
})
export class PagoPageComponent implements OnInit {
  idQuiniela: string;
  quiniela: Quiniela;

  constructor(
    private rutaActiva: ActivatedRoute,
    private QuinielasService: QuinielasService,
  ) { }

  ngOnInit(): void {
    // Obtener por parametro de URL de la Quiniela
    this.idQuiniela = this.rutaActiva.snapshot.params.id;

    // Obtener la Quiniela
    this.getQuinielaById();
  }

  getQuinielaById(): void {
    this.QuinielasService.getQuiniela(this.idQuiniela).subscribe((item) => {
      this.quiniela = {
        $key: item.payload.id,
        ...item.payload.data(),
      };
    });
  }

}
